import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";

export interface ReportLock {
	report_id?: string;
	report_type?: string;
	locked_by_email: string;
	locked_by_name?: string;
	locked_at?: string;
}

export interface LockReportPayload {
	report_id: string;
	report_type: string;
	user?: {
		email?: string;
		name?: string;
	};
}

export interface UnlockReportPayload {
	report_id: string;
	report_type: string;
	user_email: string;
}

export const lockReport = async (
	payload: LockReportPayload
): Promise<ReportLock> => {
	try {
		const response = await axios.post(
			`${url}/report_locks/lock`,
			payload,
			AuthHeader
		);
		return response.data;
	} catch (error) {
		console.error("Failed to lock report", error);
		throw error;
	}
};

export const unlockReport = async (
	payload: UnlockReportPayload
): Promise<void> => {
	try {
		await axios.post(`${url}/report_locks/unlock`, payload, AuthHeader);
	} catch (error) {
		console.error("Failed to unlock report", error);
		throw error;
	}
};

export const forceUnlockReport = async (
	payload: Pick<LockReportPayload, "report_id" | "report_type">
): Promise<void> => {
	try {
		await axios.post(`${url}/report_locks/force_unlock`, payload, AuthHeader);
	} catch (error) {
		console.error("Failed to force unlock report", error);
		throw error;
	}
};

export const getActiveReportLock = async (
	report_id: string,
	report_type: string
): Promise<ReportLock | null> => {
	try {
		const response = await axios.get(`${url}/report_locks/active`, {
			params: { report_id, report_type, _t: Date.now() },
			...AuthHeader,
		});
		return response.data?.locked_by_email ? response.data : null;
	} catch (error) {
		console.error("Failed to get active report lock", error);
		return null;
	}
};
